import { CrmFieldFilter } from "types/Models/crmFields";

const EMPTY_FILTERS: CrmFieldFilter[] = [];

const isFilterShaped = (entry: unknown): entry is CrmFieldFilter =>
  typeof entry === "object" &&
  entry !== null &&
  "field_key" in entry &&
  typeof (entry as CrmFieldFilter).field_key === "string";

/**
 * Unpacks the base64url blob written by encodeCrmFilters.
 *
 * The param is opaque, so a hand-edited or truncated URL is expected rather
 * than exceptional - every failure path returns no filters so the list still
 * renders instead of blanking out.
 */
export const decodeCrmFilters = (encoded: string | null): CrmFieldFilter[] => {
  if (!encoded) {
    return EMPTY_FILTERS;
  }

  const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/");

  try {
    const binary = window.atob(base64);
    const percentEncoded = Array.from(binary)
      .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("");
    const parsed: unknown = JSON.parse(decodeURIComponent(percentEncoded));

    if (!Array.isArray(parsed)) {
      return EMPTY_FILTERS;
    }

    return parsed.filter(isFilterShaped);
  } catch {
    return EMPTY_FILTERS;
  }
};
